// src/lib/components/MpfCard/MpfCard.props.ts
type HeadingClasses = 'mpf-heading-s' | 'mpf-heading-m' | 'mpf-heading-l' | 'mpf-heading-xl';

export interface MpfCardProps {
  href?: string;
  primary?: boolean;
  disabled?: boolean;
  clickable?: boolean;
  heading?: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6 | '1' | '2' | '3' | '4' | '5' | '6';
  headingClasses?: '' | HeadingClasses;
  description?: string;
  tagText?: string;
}

export const mpfCardDefaults = { headingLevel: '3' as MpfCardProps['headingLevel'] };
